import { Component, OnInit,ViewChild } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router } from '@angular/router';
import { CommonService } from "../../_services/common.service";
import { MatDialog } from "@angular/material";
import { FlashMessagesService } from "angular2-flash-messages";
import { environment } from '../../../environments/environment';
import { MatStepper } from '@angular/material/stepper';



import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.css']
})
export class CustomerDetailComponent implements OnInit {
  public customerInfoForm: FormGroup;
  public SelectProductData: any = [];
  public data: any = {};
  shipping = [];
  public subTotal = 0;
  public storeProject: any = {};
  public totalQty = 0;
  public loading = false;
  public checkOutdata:any={};
  public activeClass: string;
  private myStepper:MatStepper;
  public countryList:Array<any>=[]; 
  constructor(private formBuilder: FormBuilder,
    private CommonProjectDataService: CommonProjectDataService,
    private router: Router,
    private CommonService: CommonService,
    private dialog: MatDialog,
    private _flashMessagesService: FlashMessagesService,
    
  ) { }

  ngOnInit() {   
    this.customerInfoForm = this.formBuilder.group({
      email: [null, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      address: [null, Validators.required],
      address2: [null],
      city: [null, Validators.required],
      state: [null, Validators.required],
      zip: [null, Validators.required],
      country: [null, Validators.required]
    });
    //this.storeProject = JSON.parse(JSON.stringify(this.CommonProjectDataService.getQuoteData()));
    // this.SelectProductData = this.CommonProjectDataService.getSelectProductData();
    //this.subTotal = this.CommonProjectDataService.getSubTotalPrice();
    //this.totalQty=this.CommonProjectDataService.getCartTotalQty();
    this.checkOutdata=this.CommonProjectDataService.getStoreCheckOut();

    //==============uncomment this code when use stepper==========
    
    // if(this.checkOutdata && this.checkOutdata.postData)
    // {
    //   this.activeClass='active';
    //   this.customerInfoForm.patchValue({
    //     email:this.checkOutdata.postData.email ,
    //     firstName: this.checkOutdata.postData.firstName,
    //     lastName: this.checkOutdata.postData.lastName,
    //     address: this.checkOutdata.postData.address,
    //     address2: this.checkOutdata.postData.address2?this.checkOutdata.postData.address2:null,
    //     city: this.checkOutdata.postData.city,
    //     state: this.checkOutdata.postData.state,
    //     zip: this.checkOutdata.postData.zip,
    //     country: this.checkOutdata.postData.country

    //   });
        
    // }
    this.storeProject = JSON.parse(localStorage.getItem("storeData"));
    this.SelectProductData = localStorage.getItem("SelectProductData") ? JSON.parse(localStorage.getItem("SelectProductData")) : [];
    this.subTotal = localStorage.getItem("totalPrice") ? Number(localStorage.getItem("totalPrice")) : 0;
    this.totalQty = localStorage.getItem("totalQty") ? parseInt(localStorage.getItem("totalQty")) : 0;
    this.countryList=this.CommonProjectDataService.getCountryList();
  }
  isFieldValid(field: string) {
    return (
      !this.customerInfoForm.get(field).valid &&
      this.customerInfoForm.get(field).touched
    );
  }
  ngAfterViewInit() {
    //console.log('test',this.myStepper._steps.length) ;
  }
  saveCustomerData(postData) {
   // this.myStepper.next();
    // this.SelectProductData[0].emailId = postData.email;
    // this.SelectProductData[0].firstName = postData.firstName;
    // this.SelectProductData[0].lastName = postData.lastName;
    // this.SelectProductData[0].address = postData.address;
    // this.SelectProductData[0].address2 = postData.address2 ? postData.address2 : '';
    // this.SelectProductData[0].city = postData.city;
    // this.SelectProductData[0].state = postData.state;
    // this.SelectProductData[0].zip = postData.zip;
    // this.SelectProductData[0].country = postData.country;
    if (this.customerInfoForm.valid)
    {
      this.verifyAddress(postData);
    }
    else{
      this.validateAllFormFields(this.customerInfoForm);
    }
    


  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  getPrice = function (postData) {
    this.loading = true;
    let optionData = {
      shop_id: this.SelectProductData[0].product[0].shop_id, //localStorage.getItem("userID"),
      order_data: this.SelectProductData,
      store_id: this.SelectProductData[0].product[0].store_id,
      address: {
        billing_address: {
          first_name: postData.firstName,
          last_name: postData.lastName,
          zip: postData.zip,
          city: postData.city,
          county: postData.country,
          state: postData.state,
          address1: postData.address
        },
        shipping_address: {
          first_name: postData.firstName,
          last_name: postData.lastName,
          zip: postData.zip,
          city: postData.city,
          county: postData.country,
          state: postData.state,
          address1: postData.address
        }
      },
      shipping_method: "",
      shipping_zip: postData.zip
    }


    this.CommonService.apiService(
      "POST",
      "store/get_prices",
      optionData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          this.data = response.data;
          this.subTotal = this.data.total_price;
          this.shipping = [];
          Object.entries(response.data.shipping_methods).forEach(
            ([skey, value]) => {
              this.shipping.push(
                {
                  key_value: skey,
                  name: value
                });
            });
          this.setChekoutData(postData);
        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );


  }

  verifyAddress = function (postData) {
    this.loading = true;
    let optionData = {
      shop_id: this.SelectProductData[0].product[0].shop_id,
      email: postData.email,
      name: postData.firstName + ' ' + postData.lastName,
      zip: postData.zip,
      city: postData.city,
      state: postData.state,
      country: postData.country,
      address1: postData.address
      //phone: '666 666-6666'
    }
    this.CommonService.apiService(
      "POST",
      "store/verifyAddress",
      optionData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          this.getPrice(postData);
        } else if (response.status === false && response.easypost_status && response.easypost_status == "0") {
          this.loading = false;
          this._flashMessagesService.show("Your EasyPost setting is not enabled.", {
            cssClass: "alert-danger",
            timeout: 5000
          });
          window.scrollTo(0, 0);
        }

      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);
        console.log("error msg", err.error.message);
      }
    );


  }

  setChekoutData(postData) {
    let data = {
      is_public_url: 'Yes',
      turnAroundTimes: this.data.turn_around_times,
      turn_around_time: this.SelectProductData[0].product[0].turn_around_time_key ? this.SelectProductData[0].product[0].turn_around_time_key : 0,
      turnAroundName: this.SelectProductData[0].product[0].turn_around_times,
      shipping_method: "local_pickup",
      shipping: this.shipping,
      orderType: 'Quote',
      order_id: this.SelectProductData[0].product[0].order_id,
      user_id: this.SelectProductData[0].product[0].user_id,
      SelectProductData: this.SelectProductData,
      priceData: this.data,
      postData: postData
    }
    this.CommonProjectDataService.storeCheckOut(data);    
    this.router.navigate(["store/payment"]);
   
  }
  clearLocalStorage() {
    localStorage.removeItem('storeData');
    localStorage.removeItem('SelectProductData');
    localStorage.removeItem('totalPrice');
    localStorage.removeItem('totalQty');
    localStorage.removeItem('totalCartProduct');

  }
  callAction(value) {
    if (value == 'save') {      
      this.saveCustomerData(this.checkOutdata.postData);
    }
  }
  setStepper(stepper: MatStepper){
    this.myStepper=stepper;    
  }
  

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/customer-detail/customer-detail.component.ts